import "../../style.css";

import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import { createSlug } from "../../createSlug";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import labelsData from "../../labels.json";
import PixiExample from "./initPortfolioHero";

const Portfolio_Hero = () => {
  // Read the slug from the current URL
  const { pathname } = useLocation();
  const slug = pathname.split("/").pop();

  // Find the corresponding imageUrl and depthMapUrl from labels.json based on the slug
  const portfolioItem =
    labelsData.find((item) => createSlug(item.title) === slug) || {};
  const { imageUrl, depthMapUrl } = portfolioItem;
  const sectionRef = useRef(null);
  const [contentLoaded, setContentLoaded] = useState(false);

  const handleIntersection = () => {
    setContentLoaded(true);
  };

  const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

  return (
    <div
      ref={sectionRef}
      className={`loading-container${
        contentLoaded ? "" : " loading-spinner-container"
      }`}
    >
      {contentLoaded ? (
        <section
          className={`portfolio_hero${isVisible ? " fade-in-observer" : ""}`}
          id="portfolio_hero"
        >
          <PixiExample
            imageUrl={imageUrl}
            depthMapUrl={depthMapUrl}
            title={portfolioItem.title}
          />
        </section>
      ) : (
        <div className="observer_spinner"></div>
      )}
    </div>
  );
};

export default Portfolio_Hero;
